import {PageData} from "/src/domain/shared/Page";

export interface ChallengeRatingData extends PageData {
    readonly partners: string[];
    readonly currentSeasonId: number;
    readonly seasons: Season[];
    readonly ratingParticipants: ParticipantRating[];
    readonly ratingTrainers: Trainer[];
    readonly clubs: ClubRating[];
}

export interface Season {
    readonly id: number;
    readonly name: string;
    readonly organization: string;
}

export interface ParticipantRating {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly place: number;
    readonly rating: number;
    readonly movement: Movement;
    readonly clubLogoUrl?: string;
    readonly avatarUrl?: string;
}

export interface Trainer {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly place: number;
    readonly averagePlaceInRating: number;
    readonly studentsInRating: number;
    readonly movement: Movement;
}

export interface ClubRating {
    readonly id: string;
    readonly clubKey: string;
    readonly name: string;
    readonly place: number;
    readonly averagePlaceInRating: number;
    readonly participantsInRating: number;
    readonly movement: Movement;
    readonly logoUrl: string;
}

export interface RatingSeasonData {
    readonly ratingParticipants: ParticipantRating[];
    readonly ratingTrainers: Trainer[];
    readonly clubs: ClubRating[];
}

export enum Movement {
    UP = "up",
    DOWN = "down",
    IN_PLACE = "in_place"
}